import { combineReducers } from "redux";
import { accountReducer } from "./accountReducer";
import appConfigReducer from "./appConfigReducer";
import { billerReducer } from "./billerReducer";
import { balanceReducer } from "./balanceReducer";
import { paymentSettingsReducer } from "./paymentSettingsReducer";
import { retailerReducer } from "./retailerReducer";
import { billerConfigurationReducer } from "./billerConfigurationReducer";
import { paymentIntentReducer } from "./paymentIntentReducer";
import appStateReducer from "./appStateReducer";
import { walletReducer } from "./walletReducer";
import { USER_LOGOUT } from "actions/userActions";
import {
  recentPaymentsReducer,
  upcomingPaymentReducer,
} from "./paymentHistoryReducer";
import retailerLocationReducer from "./retailerLocationsReducer";
import { labelsReducer } from "./labelsReducer";
import selectedPayableTypeReducer from "./selectedPayableTypeReducer";
import payableSessionReducer from "./payableSessionReducer";

const rootReducers = {
  appState: appStateReducer,
  config: appConfigReducer, // remove it as it is never been used
  biller: billerReducer,
  account: accountReducer, // this is for old flow we will remove it gradually also remove related API calls
  balance: balanceReducer, // this is for old flow we will remove it gradually also remove related API calls
  paymentSettings: paymentSettingsReducer, // this is for old flow we will remove it also remove related API calls
  retailers: retailerReducer, // this is related to RCP need to check it when we have RCP payments implemented for payable
  billerConfiguration: billerConfigurationReducer, // this is related to RCP need to check it when we have RCP payments implemented for payable
  paymentIntent: paymentIntentReducer,
  wallet: walletReducer,
  recentPayments: recentPaymentsReducer,
  upcomingPayment: upcomingPaymentReducer,
  retailerLocations: retailerLocationReducer, // this is related to RCP need to check it when we have RCP payments implemented for payable
  labels: labelsReducer,
  selectedPayableType: selectedPayableTypeReducer,
  payableSession: payableSessionReducer,
};

/**
 * A function that will use combineReducers to merge additional reducers with the root reducer
 * @param {*} additionalReducers
 */

export const getRootReducerWith = (additionalReducers = {}): any =>
  combineReducers({
    ...rootReducers,
    ...additionalReducers,
  });

const appReducer = combineReducers(rootReducers);

export const rootReducer = (state: any, action: any) => {
  // TODO: review the USER_LOGOUT action wiping out all state in the store.
  // We may have or want to store non-user state in the store i.e. biller configuration,
  // device fingerprint, is mobile etc. Biller configuration, specifically, shouldn't
  // have to be re-fetched as a user logging out doesn't change the biller config.
  if (action.type === USER_LOGOUT) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};
